import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import { CheckCircle2 } from 'lucide-react';

const ProfileStatusUpdate: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock API call to update status
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        variant='outlined'
        sx={{
          maxWidth: 440,
          width: '100%',
          bgcolor: '#ffffff',
          borderRadius: 4,
          boxShadow: '0 20px 25px -5px rgba(226, 232, 240, 0.6)',
          p: 4,
          textAlign: 'center',
          borderColor: 'divider',
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <CircularProgress size={44} sx={{ color: '#10b981' }} />
            <Typography variant='body1' fontWeight={500} color='text.secondary'>
              Updating your profile...
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2.5 }}>
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                bgcolor: '#ecfdf5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#10b981',
              }}
            >
              <CheckCircle2 size={40} />
            </Box>
            <Box>
              <Typography variant='h5' fontWeight={700} color='text.primary' sx={{ mb: 1 }}>
                Status Updated
              </Typography>
              <Typography variant='body2' color='text.secondary' sx={{ lineHeight: 1.6 }}>
                We have updated your profile to{' '}
                <Typography component='span' variant='body2' fontWeight={700} color='text.primary'>
                  NOT AVAILABLE
                </Typography>{' '}
                for future roles.
              </Typography>
            </Box>
            <Typography variant='caption' color='text.disabled'>
              You can update your profile at any time by logging into your account.
            </Typography>
            <Button
              fullWidth
              variant='contained'
              onClick={() => {
                window.location.href = '/login';
              }}
              sx={{
                mt: 1,
                py: 1.5,
                bgcolor: '#10b981',
                color: '#ffffff',
                borderRadius: 3,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.2)',
                '&:hover': {
                  bgcolor: '#059669',
                },
              }}
            >
              Go to Login
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ProfileStatusUpdate;
